import { render } from "./PageMain.vue?vue&type=template&id=a669de7c&ts=true"
import script from "./PageMain.vue?vue&type=script&lang=ts"
export * from "./PageMain.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__